import { z } from 'zod';

/**
 * What a moderator decided about an appeal.
 *
 * Two values, and there is deliberately no third. An appeal is a yes/no question
 * about an enforcement that already happened — "does this stand?" — and a
 * `partially_upheld` would be a consequence nobody could describe to the member
 * it lands on, because the actions (`warn`, `hide_message`, `suspend`, `ban`)
 * have no partial form.
 *
 * - `upheld` — the enforcement stands. The violation keeps counting against the
 *   member (`countsAgainstMember`).
 * - `overturned` — the enforcement was wrong. It stops counting, and the action
 *   is reversed wherever it holds a state (`isReversibleViolationAction`).
 */
export const APPEAL_RESOLUTIONS = ['upheld', 'overturned'] as const;

export const AppealResolutionSchema = z.enum(APPEAL_RESOLUTIONS);

export type AppealResolution = (typeof APPEAL_RESOLUTIONS)[number];

/**
 * The violation status an appeal verdict lands the row in.
 *
 * The two vocabularies coincide today, which is exactly why this mapping is
 * written down rather than assumed: `ViolationStatus` describes the *case* and
 * `AppealResolution` the *verdict*, and a future status (`partially_upheld`, an
 * escalation) would break a call site that had quietly used one as the other.
 */
export function violationStatusForAppeal(resolution: AppealResolution): 'upheld' | 'overturned' {
  return resolution;
}
